module.exports = __webpack_public_path__ + "cancellara-dist/img/mooney.2e9c6c76.png";